
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

import AutomuteResolverButton from './AutomuteResolverButton.vue'

declareVrunComponent('automuteResolverButton.vrun.component', AutomuteResolverButton)

